export default "__VITE_ASSET__4eafa5fd__"